module.exports = __webpack_public_path__ + "static/media/Articuno_gaussian2.734aa9ff.png";